import React, { Component } from 'react';
import Projectname from './projectname.jsx'
import moment from 'moment'
import { calculateDuration } from '../api/timeListProcess';
import { colorToHex } from '../api/color';
import Record from './recordComponent.jsx'
import {Collapse } from 'react-bootstrap';

class Mergedrecord extends Component {

  constructor(props){
    super(props)
    this.state = { open:false }
    this.handleOpen = this.handleOpen.bind(this)
  }

  handleOpen(){
    this.setState({open: !this.state.open})
  }

  render() {
    const duration = calculateDuration(this.props.times.list)
    const start = moment(this.props.times.list[this.props.times.list.length-1].start).locale('en').format('H:mm')
    const end = moment(this.props.times.list[0].end).locale('en').format('H:mm')
    return (
      <div className="merged-record">
        <div className="record-card">
          <label className="name-label" onClick={this.handleOpen}>
            <span>
              {this.props.times.list.length}
            </span>
            {" " +this.props.times.name}
          </label>
          <div className="project-name-div" onClick={this.handleOpen}>
            <Projectname color={colorToHex(this.props.times.project.color)}>{this.props.times.project.name}</Projectname>
          </div>
          <div className="record-time">
            <div className="pull-right" onClick={this.handleOpen}>
              <i>
                { start } - { end }
              </i>
            </div>   
            <div className="pull-left">
              <b>
                {duration}
              </b>
              <span className="record-control">
                <i className="glyphicon glyphicon-play" onClick={this.props.startSameRecord.bind(null, this.props.times.list[0])} ></i>
                <i className="glyphicon glyphicon-list" onClick={this.handleOpen}></i>
              </span>
            </div>
          </div>
        </div>
        <Collapse in={this.state.open}>
          <div className="merged-records-list">
            {this.props.times.list.map((time)=>(
              <Record startSameRecord={this.props.startSameRecord} deleteRecord={this.props.deleteRecord} updateRecord={this.props.updateRecord} key={time.id} time={time} />
            ))}
          </div>
        </Collapse>
      </div>
    );
  }
}

Mergedrecord.defaultProps = {
  times : { list:[] },
  updateRecord: ()=>{},
  deleteRecord: ()=>{},
  startSameRecord: ()=>{}
}
export default Mergedrecord;
